import styled from 'styled-components';


const ContainerStyle = styled.div`
    height: 100%;

    >div {
        height: 100%;
    }
    
    #rc-wrapper-l2care {
        > main {
            height: 100%;

            > div {
                height: 100%;
                flex-direction: column;
    
                min-height: calc(100vh - (56px + 16px + 16px + 30px)); /*header height + two margins + footer, todo, add them to const*/
    
                >div {
                    height: 100%;
                    margin-top: 0;
                }
            }
        }

        > footer {
            display: none;
        }
    }

    .react-datepicker-popper {
        >div >div {
          min-height: 304px;
        }
      }
`;

export default {
    ContainerStyle,
};
